import { gql } from '@grandvisionhq/graphql';

const receiptUrlFailure = gql`
  fragment ReceiptUrlFailureFragment on GetReceiptUrlFailureResponse {
    failures {
      ... on GetReceiptUrlInvalidOrderStatus {
        reason
      }
      ... on GetReceiptUrlInvalidCustomerInfo {
        reason
      }
      ... on GenericFailure {
        reason
      }
    }
  }
`;

export { receiptUrlFailure };
//# sourceMappingURL=get-receipt-url-failure.js.map
